<template>
  <v-btn
    depressed
    class="yellow-button"
    :to="to"
    :href="href"
    :disabled="disabled"
    @click="doClick($event)"
  >
    <slot></slot>
  </v-btn>
</template>
<script>
//I would like to add some properties to this like small, medium, large and then color schene since
//  we have so many different button styles
export default {
  data() {
    return {
      // ...
    };
  },
  methods: {
    doClick(event) {
      this.$emit("click", event);
    }
  },
  props: ["disabled", "to", "href"]
};
</script>
<style lang="sass" scoped>
.yellow-button.v-btn:not(.v-btn--round)
  height: 32px
  border-radius: 4px
  background-color: #FCBE32 !important

.yellow-button.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).theme--light
  background-color: rgba(252, 190, 50, .25) !important

.yellow-button
  ::v-deep .v-btn__content
    color: $color-pt-royal
    font-size: 16px
    font-weight: bold
    line-height: 20px
</style>
